import React from "react";
import { Helmet } from "react-helmet-async";

import slideMiniWebp from "assets/images/landingAir/newyear/slide-mini-lg.webp";
import slideMiniWebpSm from "assets/images/landingAir/newyear/slide-mini-sm.jpg?as=webp";

import springAir from "assets/images/landingAir/hero/spring-air-slide/spring-air-slide-lg.jpg";
import springAirSm from "assets/images/landingAir/hero/spring-air-slide/spring-air-slide-sm.jpg";

import auAir from "assets/images/landingAir/hero/au-hero-slide/mila-air-au-lg.png";
import auAirSm from "assets/images/landingAir/hero/au-hero-slide/mila-air-au-sm.png";

import newAirWebp from "assets/images/landingAir/newyear/mila-air-specs.png?as=webp";
import newAirWebpSm from "assets/images/landingAir/newyear/mila-air-specs-sm.png?as=webp";

import {
  HERO_REGION_KEYS,
  resolveHeroRegionKey,
  buildHeroPreloadLinks,
} from "./heroImagePreload.helpers";

// Keep this map in sync with the region logic in HeroAirSliderChristmas.jsx:
// US -> AirMiniSlide, CA -> SpringAirSlide, AU -> AUAirSlide, otherwise ImmersiveAir.
// Each entry must mirror the matching slide's ImageLoader: the same desktop/mobile
// asset URLs and the same `responsiveWidth` (ImageLoader defaults to 768; ImmersiveAir
// passes 1024) so the preload's media query matches the <picture> the browser paints.
const HERO_PRELOAD_ASSETS = {
  [HERO_REGION_KEYS.US]: {
    desktop: slideMiniWebp,
    mobile: slideMiniWebpSm,
    type: "image/webp",
    responsiveWidth: 768,
  },
  [HERO_REGION_KEYS.CA]: {
    desktop: springAir,
    mobile: springAirSm,
    type: "image/jpeg",
    responsiveWidth: 768,
  },
  [HERO_REGION_KEYS.AU]: {
    desktop: auAir,
    mobile: auAirSm,
    type: "image/png",
    responsiveWidth: 768,
  },
  [HERO_REGION_KEYS.DEFAULT]: {
    desktop: newAirWebp,
    mobile: newAirWebpSm,
    type: "image/webp",
    responsiveWidth: 1024,
  },
};

const HeroImagePreload = ({ region }) => {
  const assets = HERO_PRELOAD_ASSETS[resolveHeroRegionKey(region)];
  const links = buildHeroPreloadLinks(assets);

  return (
    <Helmet>
      {links.map((link) => (
        <link key={link.href} {...link} />
      ))}
    </Helmet>
  );
};

export default HeroImagePreload;
